const headers = [
  {
    value: 'supplierId',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'supplierName',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'productCategoryId',
    sortable: false,
    align: ' d-none'
  },
  {
    text: 'id',
    value: 'productId',
    sortable: true,
    width: '3%',
    align: 'center'
  },
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '8%',
    align: 'center'
  },
  {
    text: 'product.product_product-number',
    value: 'productNumber',
    sortable: true,
    width: '8%'
  },
  {
    text: 'product.product_gtin-code',
    value: 'gtinCode',
    sortable: true,
    width: '10%'
  },
  {
    text: 'common.product_product-name',
    value: 'productInfo',
    sortable: true,
    width: '13%'
  },
  {
    text: 'sale.sale_product-category',
    value: 'categoryId',
    sortable: true,
    width: '9%',
    align: 'center'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'taxId',
    sortable: true,
    width: '5%',
    align: 'center'
  },
  {
    text: 'common.product_capacity',
    value: 'capacity',
    sortable: true,
    width: '5%',
    align: 'center'
  },
  {
    text: 'product.product_weight',
    value: 'weight',
    sortable: true,
    width: '5%',
    align: 'center'
  },
  {
    text: 'product.product_lot',
    value: 'lotQuantity',
    sortable: true,
    width: '5%',
    align: 'center'
  },
  {
    text: 'product.product_reference-url',
    value: 'url',
    sortable: true,
    width: '7%'
  },
  {
    text: 'product.product_market-price-tax-excluded',
    value: 'taxExcludedRetailPrice',
    sortable: true,
    width: '8%',
    align: 'end'
  },
  {
    text: 'product.product_purchase-price-tax-excluded',
    value: 'purchasePrice',
    sortable: true,
    width: '8%',
    align: 'end'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '7%',
    align: 'center'
  }
]

export default { headers }
